module.exports = __webpack_public_path__ + "img/change-password-fill.8eeca308.svg";